import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 搜索线路
export function queryRoutings(params) {
  return request({
    url: URL.booking.airExport.queryRoutings,
    method: 'get',
    params
  })
}

// 保存线路
export function saveRoutings(data, params) {
  return request({
    url: URL.booking.airExport.saveRoutings,
    method: 'post',
    data,
    params
  })
}

// 删除线路
export function deleteRoutings(params) {
  return request({
    url: URL.booking.airExport.deleteRoutings,
    method: 'delete',
    params
  })
}
